var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Product"},[(_vm.bannerPath)?_c('img',{attrs:{"src":_vm.bannerPath},on:{"click":function($event){_vm.jump()}}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }